import { IDropdownOption } from "office-ui-fabric-react";
import { WsSalesClient, WsSalesCapabilityItem } from "./core";
import * as http from "./http";

const areas: any[] = [
  {
    Name: "Core",
    Description:
      "Enables the provisioning & management of user-customized Windows 11 devices through a secure, cloud-based solution anywhere. Enhances organizational visibility of endpoint devices & end-user experiences. Leverages Microsoft enterprise licensing entitlements to provide greater ROI.",
  },
  {
    Name: "Security",
    Description:
      "The Security offering is a holistic, cloud-delivered endpoint security solution that focuses on enabling employees to be productive, while protecting company data. This is done using a zero-trust mindset to verify access explicitly.",
  },
  {
    Name: "Virtualization",
    Description:
      "Enables secure, hybrid work through cloud-based desktop and app virtualization. It offers high-performance and low-latency solutions to employees everywhere. Leverages Microsoft enterprise licensing entitlements to provide greater ROI.",
  },
  {
    Name: "Manage & Evolve",
    Description:
      "Enables secure, hybrid work through cloud-based desktop and app virtualization. It offers high-performance and low-latency solutions to employees everywhere. Leverages Microsoft enterprise licensing entitlements to provide greater ROI.",
  },
];

const getAllAreas = () => {
  return areas;
};

const capabilitiesDescription: any = {
  "Core/Hardware": `HP offers a broad portfolio of business devices, with enterprise-class security, premium design, and cutting-edge collaboration features, to keep your hybrid workforce connected, productive, and secure.`,
  "Core/Factory Services": `Devices configured directly at the factory ready for delivery to end users.`,
  "Core/Asset Services": `Resolve employee device issues with minimal impact to IT teams with services that bring rapid repair and replacement to wherever they’re needed most.`,
  "Core/Logistics": `Packaged or custom services for the deployment of HP hardware on your terms with flexible delivery options.`,
  "Core/Renew Services": `HP helps IT phase out end-of-use devices securely and responsibly with services that provide options that benefit the business and the environment.`,
  "Core/Intune": `Intune enables the provisioning & management of user-customized Windows 11 devices through a secure, cloud-based solution anywhere. Enhances organizational visibility of endpoint devices & end-user experiences. Leverages Microsoft enterprise licensing entitlements to provide greater ROI.`,
  "Core/Windows 11": `Windows 11 is designed for organizations that have a hybrid work strategy for their employees enabling them to be productive and collaborative from anywhere. It also provides the foundation for an organizations zero-trust journey. Leverages Microsoft enterprise licensing entitlements to provide greater ROI.`,
  "Core/Autopilot": `Autopilot enables the automatic provisioning of user-customized Windows 11 devices through a secure, cloud-based solution anywhere. Leverages Microsoft enterprise licensing entitlements to provide greater ROI.`,
  "Core/Applications": `Applications should be normalized and rationalized as part of a device strategy to ensure that repackaging and compatibility work is only done on the apps that really matter to an organization. Application compatibility is key for employees to get a good experience in the new environment.`,
  "Core/Endpoint Analytics": `Endpoint Analytics provides insights for measuring the quality of the experience being delivered to employees. It aims to improve employee productivity and reduce TCO by providing statistical analysis on the employee experience.`,
  "Core/Proactive Insights": `Optimize device performance, management and employee satisfaction with HP's digital service and proactively help minimize  productivity disruptions. Anticipate, identify, and resolve endpoint problems with services that use artificial intelligence and automation to give IT more visibility and control into issues before they make an impact on business.`,

  "Security/Defender for Endpoint": `Microsoft Defender for Endpoint (DFE) is an industry-leading, cloud-powered endpoint security solution that helps to secure against ransomware, file-less malware, and other sophisticated attacks on Windows, macOS, Linux, Android, and iOS devices.`,
  "Security/Windows Hello": `Windows Hello for Business (WHfB) streamlines the user authentication process by allowing an employee to authenticate to their devices and apps using biometrics, PIN or security keys. This approach is more secure than traditional credentials, and uses dedicated security hardware within the device to store critical keys & certificates.`,
  "Security/Secured-Core PC": `Secured-Core PC (SCPC) is introduced with Windows 11 and is a zero-trust architecture aimed at companies who require a higher level of security because of their industry. Secured-Core devices are protected against firmware, memory and other threats from the chip-level to the cloud.`,
  "Security/HP Wolf Security": `HP helps fortify the first line of defense with HP Wolf endpoint security solutions that safeguard people, devices, and data. Endpoint security that sits below, in and above the OS.`,
  "Security/Bitlocker": `BitLocker Drive Encryption (BDE) is a data protection feature that integrates with the operating system and addresses the threats of data theft or exposure from lost, stolen, or inappropriately decommissioned computers.`,
  "Security/HP BIOS Configuration Utility (BCU)": `The HP BIOS Configuration Utility (BCU) is a free command line utility which provides the ability to manage BIOS settings on HP supported desktop, workstation and notebook computers.`,

  "Virtualization/Azure Virtual Desktop": `Azure Virtual Desktop is a flexible, secure, and scalable cloud VDI platform that delivers virtual desktops and app streaming (see separate slide) to employees.`,
  "Virtualization/Windows 365": `Windows 365 provides highly available, optimized, and scalable cloud PCs that can be streamed to any internet-connected device wherever the employee may be.`,
  "Virtualization/App Streaming": `App streaming is a feature that allows users to access their applications remotely. Applications are streamed from a cloud server to the employees' device where they can interact with them as if they were running locally. Users can use remote app streaming to access their apps anywhere, on any device.`,

  "Manage & Evolve/M365 Services": `Azure Virtual Desktop is a flexible, secure, and scalable cloud VDI platform that delivers virtual desktops and app streaming (see separate slide) to employees.`,
  "Manage & Evolve/Security Services": `Azure Virtual Desktop is a flexible, secure, and scalable cloud VDI platform that delivers virtual desktops and app streaming (see separate slide) to employees.`,
  "Manage & Evolve/Factory Services": `Devices configured directly at the factory ready for delivery to end users.`,
  "Manage & Evolve/Asset Services": `Resolve employee device issues with minimal impact to IT teams with services that bring rapid repair and replacement to wherever they’re needed most.`,
  "Manage & Evolve/Logistics": `Packaged or custom services for the deployment of HP hardware on your terms with flexible delivery options.`,
  "Manage & Evolve/Renew Services": `HP helps IT phase out end-of-use devices securely and responsibly with services that provide options that benefit the business and the environment.`,
  "Manage & Evolve/XMO": `Azure Virtual Desktop is a flexible, secure, and scalable cloud VDI platform that delivers virtual desktops and app streaming (see separate slide) to employees.`,
  "Manage & Evolve/Proactive Insights": `Optimize device performance, management and employee satisfaction with HP's digital service and proactively help minimize  productivity disruptions. Anticipate, identify, and resolve endpoint problems with services that use artificial intelligence and automation to give IT more visibility and control into issues before they make an impact on business.`,
  "Manage & Evolve/Productivity Studio": `Azure Virtual Desktop is a flexible, secure, and scalable cloud VDI platform that delivers virtual desktops and app streaming (see separate slide) to employees.`,
};

const getCapabilityDescription = (key: string) => {
  return capabilitiesDescription[key];
};

const capabilitiesCsv = `
Core,Hardware,70,80,80,80,80,1
Core,Factory Services,90,70,80,70,100,2
Core,Asset Services,70,80,60,90,100,3
Core,Logistics,90,70,60,50,100,4
Core,Renew Services,80,70,60,50,100,5
Core,Intune,80,50,80,100,80,6
Core,Windows 11,80,80,50,50,50,7
Core,Autopilot,80,80,80,100,80,8
Core,Applications,80,80,100,80,80,9
Core,Endpoint Analytics,80,50,50,80,80,10
Core,Proactive Insights,80,80,60,90,100,11
Security,Defender for Endpoint,90,100,80,100,100,12
Security,Windows Hello,100,80,80,80,80,13
Security,Secured-Core PC,80,100,80,50,70,14
Security,HP Wolf Security,80,100,50,50,90,15
Security,Bitlocker,50,80,100,100,80,16
Security,HP BIOS Configuration Utility (BCU),80,100,50,50,90,17
Virtualization,Azure Virtual Desktop,80,100,50,100,80,18
Virtualization,Windows 365,100,80,50,100,100,19
Virtualization,App Streaming,80,80,50,100,80,20
Manage & Evolve,M365 Services,80,100,50,100,80,21
Manage & Evolve,Security Services,80,100,50,100,80,22
Manage & Evolve,Factory Services,90,70,80,70,100,23
Manage & Evolve,Asset Services,70,80,60,90,100,24
Manage & Evolve,Logistics,80,70,60,50,100,25
Manage & Evolve,Renew Services,80,70,60,50,100,26
Manage & Evolve,XMO,100,80,100,50,60,27
Manage & Evolve,Proactive Insights,70,80,60,90,100,28
Manage & Evolve,Productivity Studio,100,60,100,70,60,29
`;

const capabilitiesArray: any[] = [];

capabilitiesCsv.split(/\r?\n/).forEach((value: string) => {
  if (value && value.length > 0) {
    const columns = value.split(",");
    capabilitiesArray.push(columns);
  }
});

// console.log(capabilitiesArray);

const capabilities: any[] = [];

capabilitiesArray.forEach((value: string[]) => {
  const capability: any = {
    Position: parseInt(value[7]),
    Area: value[0],
    Name: value[1],
    Description: getCapabilityDescription(`${value[0]}/${value[1]}`),
    "Employee Experience": parseInt(value[2]),
    "Cyber Security": parseInt(value[3]),
    "Increased ROI": parseInt(value[4]),
    "Reduced TCO": parseInt(value[5]),
    "Operational Efficiency": parseInt(value[6]),
  };

  capabilities.push(capability);
});

// console.log(capabilities);

const getAllCapabilities = () => {
  return capabilities;
};

const getPriorities = () => {
  if (process.env.NODE_ENV === "development") {
    return {
      "Employee Experience": 90,
      "Cyber Security": 80,
      "Increased ROI": 70,
      "Reduced TCO": 60,
      "Operational Efficiency": 50,
    };
  } else {
    return {
      "Employee Experience": 100,
      "Cyber Security": 100,
      "Increased ROI": 100,
      "Reduced TCO": 100,
      "Operational Efficiency": 100,
    };
  }
};

const apiGet = async (url: string): Promise<any | undefined> => {
  const reqUrl = url.toLowerCase().startsWith("http") ? url : `/api${url}`;

  const result: any = await http.get<any>(reqUrl);

  if (result) {
    return result;
  } else {
    return [];
  }
};

const apiPost = async (
  url: string,
  data: any,
  headers?: any,
): Promise<any | undefined> => {
  const result: any = await http.post<any>(`/api${url}`, data, headers);

  if (result) {
    return result;
  } else {
    return [];
  }
};

const apiPut = async (
  url: string,
  data: any,
  headers?: any,
): Promise<any | undefined> => {
  const result: any = await http.put<any>(`/api${url}`, data, headers);

  if (result) {
    return result;
  } else {
    return [];
  }
};

const apiDelete = async (url: string): Promise<any | undefined> => {
  const result: any = await http.delete<any>(`/api${url}`);

  if (result) {
    return result;
  } else {
    return [];
  }
};

export const getSalesTemplates = () => {
  return [
    { id: 1, name: "Engagement" },
    { id: 2, name: "ROM" },
    { id: 3, name: "Proposal" },
    { id: 3, name: "Solution Plan (SP051)" },
  ];
};

const getStructuredCapabilities = () => {
  /*
  {
    name: '',
    area: '',
    children: []
  }
  */

  const list: WsSalesCapabilityItem[] = [
    {
      name: "Core",
      area: "Core",
      children: [
        {
          name: "Hardware",
          area: "Core",
          children: [
            {
              name: "Factory Services",
              area: "Core",
              children: [],
            },
            {
              name: "Asset Services",
              area: "Core",
              children: [],
            },
            {
              name: "Logistics",
              area: "Core",
              children: [],
            },
            {
              name: "Renew Services",
              area: "Core",
              children: [],
            },
          ],
        },

        {
          name: "Windows Client",
          area: "Core",
          children: [
            {
              name: "Intune",
              area: "Core",
              children: [
                {
                  name: "Autopilot",
                  area: "Core",
                  children: [],
                  scope: [
                    {
                      name: "Azure AD Join",
                      items: [
                        {
                          name: "Setup & Configure Autopilot",
                          items: [
                            {
                              id: "Azure AD Join/Setup & Configure Autopilot/1",
                              name: "Create a Dynamic Azure AD Autopilot Group",
                              effort: 1,
                            },
                            {
                              id: "Azure AD Join/Setup & Configure Autopilot/2",
                              name: "Create an Autopilot Deployment Profile",
                              effort: 1,
                            },
                            {
                              id: "Azure AD Join/Setup & Configure Autopilot/3",
                              name: "Create and configure Enrollment Status Page",
                              effort: 1,
                            },
                          ],
                        },
                        {
                          name: "Integration Test",
                          items: [
                            {
                              id: "Azure AD Join/Integration Test/1",
                              name: "Test & Validate Use Cases",
                              effort: 8,
                            },
                            {
                              id: "Azure AD Join/Integration Test/2",
                              name: "Remediate Integration Test Issues",
                              effort: 24,
                            },
                          ],
                        },
                        {
                          name: "User Acceptance Testing",
                          items: [
                            {
                              id: "Azure AD Join/User Acceptance Testing/1",
                              name: "Faciliate User Acceptance Test of the Use Cases",
                              effort: 8,
                            },
                            {
                              id: "Azure AD Join/User Acceptance Testing/2",
                              name: "Remediate UAT Issues",
                              effort: 24,
                            },
                          ],
                        },
                      ],
                    },

                    {
                      name: "Hybrid AD Join",
                      items: [
                        {
                          name: "Customer Workshop",
                          items: [
                            {
                              id: "Hybrid AD Join/Customer Workshop/1",
                              name: "Complete Design Docs",
                              effort: 16,
                            },
                            {
                              id: "Hybrid AD Join/Customer Workshop/2",
                              name: "Test Use Cases",
                              effort: 12,
                            },
                          ],
                        },
                        {
                          name: "Setup & Configure Hybrid AD Join",
                          items: [
                            {
                              id: "Hybrid AD Join/Setup & Configure Hybrid AD Join/1",
                              name: "Intune Connector Server PreRecs",
                              effort: 4,
                            },
                            {
                              id: "Hybrid AD Join/Setup & Configure Hybrid AD Join/2",
                              name: "Define AD OU Container for Machine accounts",
                              effort: 1,
                            },
                            {
                              id: "Hybrid AD Join/Setup & Configure Hybrid AD Join/3",
                              name: "Delegate Intune Connector server rights to OU",
                              effort: 1,
                            },
                            {
                              id: "Hybrid AD Join/Setup & Configure Hybrid AD Join/4",
                              name: "Install Intune Connector",
                              effort: 2,
                            },
                            {
                              id: "Hybrid AD Join/Setup & Configure Hybrid AD Join/5",
                              name: "Turn Off IE Enhanced Security Configuration on Server",
                              effort: 1,
                            },
                            {
                              id: "Hybrid AD Join/Setup & Configure Hybrid AD Join/6",
                              name: "Create a Hybrid Azure AD Autoplot Device group",
                              effort: 1,
                            },
                            {
                              id: "Hybrid AD Join/Setup & Configure Hybrid AD Join/7",
                              name: "Create Hybrid Azure AD join Autopilot Profile",
                              effort: 1,
                            },
                            {
                              id: "Hybrid AD Join/Setup & Configure Hybrid AD Join/8",
                              name: "Assign the Hybrid Azure Doman join profile",
                              effort: 1,
                            },
                            {
                              id: "Hybrid AD Join/Setup & Configure Hybrid AD Join/9",
                              name: "Validate Hybrid Azure Domain Join",
                              effort: 2,
                            },
                          ],
                        },
                        {
                          name: "Integration Test",
                          items: [
                            {
                              id: "Hybrid AD Join/Integration Test/1",
                              name: "Test & Validate Use Cases",
                              effort: 8,
                            },
                            {
                              id: "Hybrid AD Join/Integration Test/2",
                              name: "Remediate Integration Test Issues",
                              effort: 32,
                            },
                          ],
                        },
                        {
                          name: "User Acceptance Testing",
                          items: [
                            {
                              id: "Hybrid AD Join/User Acceptance Testing/1",
                              name: "Faciliate User Acceptance Test of the Use Cases",
                              effort: 8,
                            },
                            {
                              id: "Hybrid AD Join/User Acceptance Testing/2",
                              name: "Remediate UAT Issues",
                              effort: 32,
                            },
                          ],
                        },
                      ],
                    },

                    {
                      name: "Application Load",
                      items: [
                        {
                          name: "Review Intune Infrastructure",
                          items: [
                            {
                              id: "Application Load/Review Intune Infrastructure/1",
                              name: "Prepare App Publishing Infratructure",
                              effort: 6,
                            },
                            {
                              id: "Application Load/Review Intune Infrastructure/2",
                              name: "Prepare Test Devices",
                              effort: 2,
                            },
                          ],
                        },
                        {
                          name: "Package & Publish Apps",
                          items: [
                            {
                              id: "Application Load/Package & Publish Apps/1",
                              name: "Gather Application Details",
                              effort: 4,
                            },
                            {
                              id: "Application Load/Package & Publish Apps/2",
                              name: "Package App",
                              effort: 10,
                            },
                            {
                              id: "Application Load/Package & Publish Apps/3",
                              name: "Publish App in Intune",
                              effort: 2,
                            },
                            {
                              id: "Application Load/Package & Publish Apps/4",
                              name: "Assign to Integration Test Group",
                              effort: 2,
                            },
                            {
                              id: "Application Load/Package & Publish Apps/5",
                              name: "Validate and Test on Int Test Device",
                              effort: 8,
                            },
                            {
                              id: "Application Load/Package & Publish Apps/6",
                              name: "Assign to Integration Test Group",
                              effort: 1,
                            },
                          ],
                        },
                        {
                          name: "Integration Test",
                          items: [
                            {
                              id: "Application Load/Integration Test/1",
                              name: "Test & Validate Use Cases",
                              effort: 4,
                            },
                            {
                              id: "Application Load/Integration Test/2",
                              name: "Remediate Integration Test Issues",
                              effort: 8,
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
              scope: [
                {
                  name: "Customer Workshop",
                  items: [
                    {
                      id: "Customer Workshop/1",
                      name: "Deliver Customer Workshop",
                      effort: 24,
                      metrics: [
                        {
                          name: "Number of Workshops",
                          value: 1,
                        },
                        {
                          name: "Length of Workshop",
                          value: 1,
                        },
                      ],
                    },
                    {
                      id: "Customer Workshop/2",
                      name: "Capture Pre-Recs and Gaps (Customer Action Plan)",
                      effort: 4,
                    },
                    {
                      id: "Customer Workshop/3",
                      name: "Complete Design Docs",
                      effort: 16,
                    },
                    {
                      id: "Customer Workshop/4",
                      name: "Test Use Cases",
                      effort: 4,
                      metrics: [
                        {
                          name: "Number of Test Use Cases",
                          value: 1,
                        },
                      ],
                    },
                  ],
                },
                {
                  name: "Review Intune Infrastructure",
                  items: [
                    {
                      id: "Review Intune Infrastructure/1",
                      name: "Discovery of the Intune / Azure Tenant",
                      effort: 4,
                    },
                  ],
                },
                {
                  name: "Setup & Configure Intune",
                  items: [
                    {
                      id: "Setup & Configure Intune/1",
                      name: "Configure MDM Authority",
                      effort: 1,
                    },
                    {
                      id: "Setup & Configure Intune/2",
                      name: "Enable Users to Join Devices to Azure AD",
                      effort: 1,
                    },
                    {
                      id: "Setup & Configure Intune/3",
                      name: "Configure Azure AD Company Branding",
                      effort: 1,
                    },
                    {
                      id: "Setup & Configure Intune/4",
                      name: "Configure Automatic MDM enrollment",
                      effort: 1,
                    },
                    {
                      id: "Setup & Configure Intune/5",
                      name: "Configure Azure AD Group Structure",
                      effort: 1,
                    },
                    {
                      id: "Setup & Configure Intune/6",
                      name: "Configure Bitlocker Configuration Profile",
                      effort: 1,
                      metrics: [
                        {
                          name: "Number of Profiles",
                          value: 1,
                        },
                      ],
                    },
                    {
                      id: "Setup & Configure Intune/7",
                      name: "Configure Defender Configuration Profile",
                      effort: 8,
                      metrics: [
                        {
                          name: "Number of Profiles",
                          value: 1,
                        },
                      ],
                    },
                    {
                      id: "Setup & Configure Intune/8",
                      name: "Review and define User license assignment",
                      effort: 1,
                    },
                    {
                      id: "Setup & Configure Intune/9",
                      name: "Configure RBAC",
                      effort: 8,
                    },
                    {
                      id: "Setup & Configure Intune/10",
                      name: "Configure Office 365 Application",
                      effort: 1,
                    },
                    {
                      id: "Setup & Configure Intune/11",
                      name: "Configure Onedrive Policy",
                      effort: 1,
                      metrics: [
                        {
                          name: "Number of Policies",
                          value: 1,
                        },
                      ],
                    },
                    {
                      id: "Setup & Configure Intune/12",
                      name: "Configure Edge Policy",
                      effort: 2,
                      metrics: [
                        {
                          name: "Number of Policies",
                          value: 1,
                        },
                      ],
                    },
                    {
                      id: "Setup & Configure Intune/13",
                      name: "Configure Delivery Optimisation",
                      effort: 1,
                    },
                    {
                      id: "Setup & Configure Intune/14",
                      name: "Configure Windows Hello Pin Policy",
                      effort: 2,
                    },
                    {
                      id: "Setup & Configure Intune/15",
                      name: "Configure Windows Update for Business",
                      effort: 8,
                    },
                  ],
                },
                {
                  name: "Integration Test",
                  items: [
                    {
                      id: "Integration Test/1",
                      name: "Test & Validate Use Cases",
                      effort: 8,
                      metrics: [
                        {
                          name: "Number of Test Use Cases",
                          value: 1,
                        },
                      ],
                    },
                    {
                      id: "Integration Test/2",
                      name: "Remediate Integration Test Issues",
                      effort: 16,
                      metrics: [
                        {
                          name: "Number of Test Use Cases",
                          value: 1,
                        },
                      ],
                    },
                  ],
                },
                {
                  name: "User Acceptance Testing",
                  items: [
                    {
                      id: "User Acceptance Testing/1",
                      name: "Faciliate User Acceptance Test of the Use Cases",
                      effort: 8,
                      metrics: [
                        {
                          name: "Number of Test Use Cases",
                          value: 1,
                        },
                      ],
                    },
                    {
                      id: "User Acceptance Testing/2",
                      name: "Remediate UAT Issues",
                      effort: 24,
                      metrics: [
                        {
                          name: "Number of Test Use Cases",
                          value: 1,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              name: "Applications",
              area: "Core",
              children: [
                {
                  name: "App Streaming",
                  area: "Virtualization",
                  children: [],
                },
              ],
            },
            {
              name: "Endpoint Analytics",
              area: "Core",
              children: [],
            },
            {
              name: "Proactive Insights",
              area: "Core",
              children: [],
            },
            {
              name: "Azure Virtual Desktop",
              area: "Virtualization",
              children: [],
            },
            {
              name: "Windows 365",
              area: "Virtualization",
              children: [],
            },
            {
              name: "Defender for Endpoint",
              area: "Security",
              children: [],
            },
            {
              name: "Secured-Core PC",
              area: "Security",
              children: [],
            },
            {
              name: "Bitlocker",
              area: "Security",
              children: [],
            },
            {
              name: "HP BIOS Configuration Utility",
              area: "Security",
              children: [],
            },
          ],
        },
      ],
    },

    {
      name: "Security",
      area: "Security",
      children: [
        {
          name: "Authentication",
          area: "Security",
          children: [
            {
              name: "Windows Hello",
              area: "Security",
              children: [],
            },
            {
              name: "Azure MFA",
              area: "Security",
              children: [],
            },
          ],
        },

        {
          name: "Security Services",
          area: "Security",
          children: [
            {
              name: "HP Wolf Security",
              area: "Security",
              children: [],
            },
          ],
        },
      ],
    },

    {
      name: "Manage & Envolve",
      area: "Manage & Envolve",
      children: [
        {
          name: "M365 Services",
          area: "Manage & Envolve",
          children: [
            {
              name: "Office 365 Platform",
              area: "Manage & Envolve",
              children: [],
            },
            {
              name: "Exchange",
              area: "Manage & Envolve",
              children: [],
            },
            {
              name: "SharePoint",
              area: "Manage & Envolve",
              children: [],
            },
            {
              name: "OneDrive",
              area: "Manage & Envolve",
              children: [],
            },
            {
              name: "Teams",
              area: "Manage & Envolve",
              children: [
                {
                  name: "Voice",
                  area: "Manage & Envolve",
                  children: [],
                },
              ],
            },
          ],
        },

        {
          name: "Security Services",
          area: "Manage & Envolve",
          children: [
            {
              name: "HP Wolf Security",
              area: "Security",
              children: [],
            },
          ],
        },

        {
          name: "Hardware",
          area: "Manage & Envolve",
          children: [
            {
              name: "Factory Services",
              area: "Manage & Envolve",
              children: [],
            },
            {
              name: "Logistics",
              area: "Manage & Envolve",
              children: [],
            },
            {
              name: "Asset Services",
              area: "Manage & Envolve",
              children: [],
            },
            {
              name: "Renew Services",
              area: "Manage & Envolve",
              children: [],
            },
          ],
        },

        {
          name: "XMO",
          area: "Manage & Envolve",
          children: [],
        },

        {
          name: "Proactive Insights",
          area: "Manage & Envolve",
          children: [],
        },

        {
          name: "Productivity Studio",
          area: "Manage & Envolve",
          children: [],
        },
      ],
    },
  ];

  return list;
};

const getSalesClients = () => {
  const list: WsSalesClient[] = [
    { id: 1, name: "Vodafone" },
    { id: 2, name: "Barclays" },
    { id: 3, name: "NatWest" },
    { id: 4, name: "NHS" },
    { id: 5, name: "Unilever" },
    { id: 6, name: "Virgin Media" },
    { id: 7, name: "Continental" },
    { id: 8, name: "Vitesco" },
    { id: 9, name: "Coca-Cola" },
    { id: 10, name: "Towergate" },
  ];

  return list;
};

export const getPersonPhoto = (email: string) => {
  const photos = {
    "m.balodis@avanade.com": "/photos/m.balodis@avanade.com.jpeg",
    "d.wood@avanade.com": "/photos/d.wood@avanade.com.jpeg",
    "d.ames@avanade.com": "/photos/d.ames@avanade.com.jpeg",
    "keith.hudgell@avanade.com": "/photos/keith.hudgell@avanade.com.jpeg",
  };

  if (photos[email]) {
    return { backgroundImage: `url(${photos[email]})` };
  } else {
    return {};
  }
};

export const getClientOptions = (salesClients: WsSalesClient[]) => {
  return salesClients.map((value) => {
    const option: IDropdownOption = {
      key: value.id ? value.id : 0,
      text: value.name,
    };
    return option;
  });
};

export {
  getSalesClients,
  apiGet,
  apiPost,
  apiPut,
  apiDelete,
  getAllAreas,
  getAllCapabilities,
  getCapabilityDescription,
  getPriorities,
  getStructuredCapabilities,
};
